/**
 * @providesModule RangeTablePrintout
 * @flow
 */

import React from 'react'

import type { RangeList } from '../../redux/state'
import { ratingText } from '../../shared/ratingText'

const RangeTablePrintout = ({
  title,
  name,
  items = [],
  first,
  Header = 'h4'
}: {
  title: string,
  name: string,
  items: RangeList,
  first?: boolean,
  Header: string
}) => (
  <div
    style={{
      flex: 1,
      marginLeft: first || '1em',
      marginRight: first && '1em',
      maxWidth: '30em',
    }}
  >
    <Header>{title}</Header>
    <table className="pt-table pt-condensed" style={{ width: '100%' }}>
      <thead>
        {' '}
        <tr>
          <th>Wavelength (nm)</th>
          <th style={{ width: '8em' }}>{name}</th>
        </tr>{' '}
      </thead>
      <tbody>
        {items.length === 0 && (
          <tr>
            <td />
            <td />
          </tr>
        )}
        {items.map(row => (
          <tr key={row.range}>
            {row.value ? <><td>{row.range}</td><td>{row.value}</td></> :
              <td colSpan="2" style={{ whiteSpace: 'pre-wrap' }}>{ratingText(row, name !== 'OD')}</td>}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
)

export default RangeTablePrintout
